import { ME_EVENT_TABS } from '@spot/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { SegmentedControl } from '../components/ui/segmented-control';
import { MineTab } from '../features/activities/mine-tab';
import { NearbyTab } from '../features/activities/nearby-tab';
import { useSession } from '../features/auth/session-gate';

type Segment = 'nearby' | 'mine';
let rememberedSegment: Segment = 'nearby';

/** S6 Activities: Поруч · Мої. */
export function ActivitiesScreen() {
	const { t } = useTranslation();
	const { me } = useSession();
	// `?view=mine&tab=saved` (profile shortcuts) opens a given list; otherwise the last one.
	const [params] = useSearchParams();
	const linkedTab = ME_EVENT_TABS.find((tab) => tab === params.get('tab'));
	const [segment, setSegmentState] = useState<Segment>(
		params.get('view') === 'mine' ? 'mine' : rememberedSegment,
	);
	const setSegment = (next: Segment) => {
		rememberedSegment = next;
		setSegmentState(next);
	};

	return (
		<div className="flex flex-col gap-2 px-4 pt-3 pb-6">
			<SegmentedControl
				label={t('tabs.activities')}
				value={segment}
				onChange={setSegment}
				options={[
					{ value: 'nearby', label: t('activities.nearby') },
					{ value: 'mine', label: t('activities.mine') },
				]}
			/>
			{segment === 'nearby' ? (
				<NearbyTab locale={me.locale} />
			) : (
				<MineTab locale={me.locale} initialTab={linkedTab} />
			)}
		</div>
	);
}
